
const formScript = function () {
    const allToggleCheckboxes = document.querySelectorAll('input[name="all"]');

    allToggleCheckboxes.forEach(toggle => {
        const parentContainer = toggle.closest('.form-style-checkarea');

        if (parentContainer) {
            const siblingCheckboxes = parentContainer.querySelectorAll('input[type="checkbox"]:not([name="all"])');
            toggle.addEventListener('change', function() {
                siblingCheckboxes.forEach(cb => {
                    cb.checked = this.checked;
                });
            });

        }
    });
}

export default formScript;